import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-gap: 0.5rem;
`;
